module.exports = __webpack_public_path__ + "static/contact-b5b3b66cb818b00d85666962efb07117.jpg";